import styled from "styled-components";

export const PageContent = styled.div`
  padding: ${({ theme }) => theme.space[4]};
  max-width: 960px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.space[5]};
`;

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.fonts.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray800};
  margin: 0;
`;

export const PageSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray400};
  margin: ${({ theme }) => theme.space[1]} 0 0 0;
`;

export const SearchActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  margin-bottom: ${({ theme }) => theme.space[5]};
  position: relative;

  .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    pointer-events: none;
    color: ${({ theme }) => theme.colors.gray400};
  }

  .search-address {
    flex: 1;
    border-radius: ${({ theme }) => theme.radius.md};
  }

  .search-address .dx-texteditor-input {
    padding-left: 36px !important;
  }

  .search-address .dx-placeholder::before {
    padding-left: 36px !important;
  }
`;

export const BtnAdd = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: ${({ theme }) => theme.radius.md};
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color ${({ theme }) => theme.transitions.fast};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

export const AddressList = styled.div``;

export const AddressItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[3]};
  padding: ${({ theme }) => theme.space[3]} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray100};
`;

export const AddressIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  background-color: ${({ theme }) => theme.colors.primaryBg};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: 18px;
`;

export const AddressText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AddressName = styled.div`
  font-size: ${({ theme }) => theme.fonts.base};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray800};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AddressDetail = styled.div`
  font-size: ${({ theme }) => theme.fonts.xs};
  color: ${({ theme }) => theme.colors.gray400};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BtnDelete = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.gray400};
  border-radius: ${({ theme }) => theme.radius.md};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background-color: ${({ theme }) => theme.colors.errorLight};
    color: ${({ theme }) => theme.colors.error};
  }
`;
